import RegionAccordion from './RegionAccordion';

export default RegionAccordion;




// WEBPACK FOOTER //
// ./src/components/Header/Region/RegionAccordion/index.js